import { z } from 'zod'

// 성공 응답 스키마: statusCode, message, data
const successResponseSchema = <T>(
  dataSchema: z.ZodType<T>,
  { isVoid = false }: { isVoid: boolean },
) =>
  isVoid
    ? z.object({
        type: z.literal('success'),
        statusCode: z.number(),
        message: z.string(),
      })
    : z.object({
        type: z.literal('success'),
        statusCode: z.number(),
        message: z.string(),
        data: dataSchema,
      })

export type SuccessResponseType<T> = T extends void
  ? {
      type: 'success'
      statusCode: number
      message: string
    }
  : {
      type: 'success'
      statusCode: number
      message: string
      data: T
    }

// 실패 응답 스키마: statusCode, message, error
const errorResponseSchema = z.object({
  type: z.literal('error'),
  statusCode: z.number(),
  message: z.string(),
  error: z.string(),
})

export type ErrorResponseType = z.infer<typeof errorResponseSchema>

export const apiResponseSchema = <T>(
  dataSchema: z.ZodType<T>,
  { isVoid = false }: { isVoid: boolean },
) =>
  z.union([successResponseSchema(dataSchema, { isVoid }), errorResponseSchema])

export type APIResponse<T> = SuccessResponseType<T> | ErrorResponseType

export const apiListResponseSchema = <T>(dataSchema: z.ZodType<T>) =>
  z.object({
    totalCount: z.number(),
    results: z.array(dataSchema),
  })

export type List<T> = z.infer<ReturnType<typeof apiListResponseSchema<T>>>

export const apiPaginationResponseSchema = <T>(dataSchema: z.ZodType<T>) =>
  z.object({
    totalPage: z.number(),
    currentPage: z.number(),
    pageSize: z.number(),
    list: z.array(dataSchema),
  })

export type APIPaginationResponse<T> = z.infer<
  ReturnType<typeof apiPaginationResponseSchema<T>>
>
